import React, { useState } from "react";
import { FUND_CANDIDATES, RISK_OPTIONS, FEE_OPTIONS } from "./data.js";

export default function ReconStage({ onComplete }) {
  const [index, setIndex] = useState(0);
  const [tags, setTags] = useState({});
  const [correctCount, setCorrectCount] = useState(0);
  const [flash, setFlash] = useState(null);

  const current = FUND_CANDIDATES[index];
  const done = index >= FUND_CANDIDATES.length;

  const chooseTag = (field, value) => {
    if (!current) return;
    const existing = tags[current.id] || {};
    const updated = { ...existing, [field]: value };
    setTags((prev) => ({ ...prev, [current.id]: updated }));

    if (updated.risk && updated.fees) {
      const bothCorrect = updated.risk === current.correctRisk && updated.fees === current.correctFees;
      if (bothCorrect) setCorrectCount((c) => c + 1);
      setFlash(bothCorrect ? "correct" : "off");
      setTimeout(() => {
        setFlash(null);
        setIndex((i) => i + 1);
      }, 600);
    }
  };

  if (done) {
    return (
      <div className="animate-popIn text-center">
        <p className="label-pixel mb-2 text-lime">Recon Complete</p>
        <h2 className="pixel-heading mb-4 text-base text-mist">Field Guide Filed</h2>

        <div className="mx-auto mb-6 max-w-sm space-y-2 border-2 border-black bg-ink p-4 text-left text-sm">
          <div className="flex justify-between">
            <span className="text-mist/60">Classified Correctly</span>
            <span className="text-lime">
              {correctCount}/{FUND_CANDIDATES.length}
            </span>
          </div>
          {FUND_CANDIDATES.map((f) => (
            <div key={f.id} className="flex justify-between text-[11px]">
              <span className="text-mist/50">{f.name}</span>
              <span className="text-gold">~{f.netAnnualReturn}%/yr</span>
            </div>
          ))}
        </div>

        <p className="mx-auto mb-6 max-w-sm text-xs text-mist/60">
          History says boring wins. A diversified, low-fee index fund has averaged roughly
          10–13% a year over long periods — not because it's exciting, but because it never bets
          everything on one company.
        </p>

        <button onClick={() => onComplete({ correctCount })} className="btn-magenta">
          CHART YOUR COURSE ▶
        </button>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-4 flex items-center justify-between font-display text-[9px] text-mist/60">
        <span>RECON</span>
        <span>
          {index}/{FUND_CANDIDATES.length} REVIEWED
        </span>
      </div>

      <p className="mb-5 text-xs text-mist/60">
        Five real ways people put money to work. Tag each by how risky it actually is, and how
        much it costs to hold.
      </p>

      <div
        key={current.id}
        className={`mb-5 border-2 border-black bg-ink p-5 transition-colors ${
          flash === "correct" ? "border-lime shadow-glow-cyan" : flash === "off" ? "border-danger" : ""
        }`}
      >
        <p className="pixel-heading mb-2 text-sm text-mist">{current.name}</p>
        <p className="text-xs leading-relaxed text-mist/70">{current.description}</p>
      </div>

      <div className="mb-4">
        <p className="label-pixel mb-2 text-mist/60">Risk Level</p>
        <div className="grid grid-cols-3 gap-2">
          {RISK_OPTIONS.map((opt) => {
            const selected = tags[current.id]?.risk === opt.id;
            return (
              <button
                key={opt.id}
                onClick={() => chooseTag("risk", opt.id)}
                className={`border-2 px-2 py-2 font-display text-[9px] uppercase transition-colors ${
                  selected ? "border-cyan bg-cyan text-ink" : "border-mist/30 text-mist/70 hover:border-cyan"
                }`}
              >
                {opt.label}
              </button>
            );
          })}
        </div>
      </div>

      <div>
        <p className="label-pixel mb-2 text-mist/60">Fees</p>
        <div className="grid grid-cols-2 gap-2">
          {FEE_OPTIONS.map((opt) => {
            const selected = tags[current.id]?.fees === opt.id;
            return (
              <button
                key={opt.id}
                onClick={() => chooseTag("fees", opt.id)}
                className={`border-2 px-3 py-2 font-display text-[9px] uppercase transition-colors ${
                  selected ? "border-magenta bg-magenta text-ink" : "border-mist/30 text-mist/70 hover:border-magenta"
                }`}
              >
                {opt.label}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
